//app/src/routers/index.js

import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "../components/common/ScrollToTop";

// Lazy load components for code splitting
const PortfolioContainer = lazy(() => import("../components/portfolio/PortfolioContainer"));
const NotFoundScreen = lazy(() => import("../components/others/NotFoundScreen"));

// Loading fallback component
const LoadingFallback = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    minHeight: '100vh',
    backgroundColor: '#000'
  }}>
    <div className="loading-spinner"></div>
  </div>
);

function index() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route exact path="/" element={<PortfolioContainer />} />
          <Route path="/:projectId" element={<PortfolioContainer />} />
          <Route exact path="/404" element={<NotFoundScreen />} />
          <Route path="*" element={<NotFoundScreen />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default index;
